export default "__VITE_ASSET__CFVnSKlk__"